import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import currencyFormatter from "currency-formatter";
import { getAnalytics } from "./api/getDonationAnalytics";
import history from "./history";
import "./index.css";
import rackerLogo from "./images/racker-logo.png";
import heroImage from "./images/hero-image.jpg";
import SocialComponent from "./components/social-component";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      raised: 0,
      goal: 25000,
      donors: 0,
      daysLeft: 90,
      showAllDonors: false,
      donationAmount: '',
      currency: 'USD'
    };
  }

  componentDidMount() {
    this.getDonorTotals();
  }

  async getDonorTotals() {
    const data = await getAnalytics();
    if (data !== undefined && data !== null && data.response) {
      this.setState({
        raised: data.response.raised,
        donors: data.response.donors,
      });
    }
  }

  handleDonate = () => {
    if (!this.state.donationAmount || parseFloat(this.state.donationAmount) <= 0) {
      alert('Please enter a valid donation amount');
      return;
    }
    history.push('/donate', { 
      amount: parseFloat(this.state.donationAmount),
      currency: this.state.currency.toLowerCase(),
      charityId: 1 // You may need to adjust this based on your requirements
    });
  };

  handleAmountChange = (e) => {
    const value = e.target.value;
    // Allow only numbers and decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      this.setState({ donationAmount: value });
    }
  };

  handleCurrencyChange = (e) => {
    this.setState({ currency: e.target.value });
  };

  handleShare = () => {
    console.log('Share clicked');
  };

  render() {
    const progressPercentage = (this.state.raised / this.state.goal) * 100;

    return (
      <div className="min-h-screen bg-gray-50">
        {/* Purple Header */}
        <div className="text-white py-12 pb-20" style={{ backgroundColor: '#7f0b86' }}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content - Left Side */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-lg shadow-lg border border-gray-300 pb-6 px-6">
                <img 
                  src={rackerLogo}
                  alt="Racker Logo" 
                  className="w-full max-h-36 object-contain"
                />
                <img 
                  src={heroImage} 
                  alt="Team collaboration" 
                  className="w-full h-96 object-contain rounded-lg mb-6"
                />
                
                <div className="prose max-w-none">
                  <p className="text-gray-700 font-bold mb-4">
                  Racker2Racker is our employee-led assistance program, created to support full-time Rackers (tenure 6+ months) when they face extraordinary financial hardships.  Whether facing a medical emergency, natural disaster, or unexpected life challenge, this program provides confidential financial support when it's needed most.
                  <p className="text-gray-700 font-bold mt-6">
                  By contributing to Racker2Racker, you are helping to create a supportive and resilient community within our organization.</p>
                  </p>
                </div>
              </div>
            </div>

            {/* Donation Panel - Right Side */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-lg border border-gray-300 sticky top-4">
                {/* Fundraising Progress */}
                <div className="p-6 pb-0">
                  <div className="flex justify-between items-baseline mb-2">
                    <span className="text-3xl font-bold" style={{ color: '#7f0b86' }}>
                      {currencyFormatter.format(this.state.raised, { code: "USD", precision: 0 })}
                    </span>
                    <span className="text-gray-500">
                      raised 
                    </span>
                  </div>
                  
                  {/* Progress Bar */}
                  <div className="w-full bg-gray-200 rounded-full h-3 mb-4">
                    <div 
                      className="h-3 rounded-full transition-all duration-500"
                      style={{ width: `${Math.min(progressPercentage, 100)}%`, backgroundColor: '#7f0b86' }}
                    />
                  </div>
                </div>

                {/* Donation Amount Input */}
                <div className="px-6 pb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Donation Amount
                  </label>
                  <div className="flex gap-2">
                    <div className="relative flex-1">
                      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                        {this.state.currency === 'USD' ? '$' : this.state.currency === 'EUR' ? '€' : '£'}
                      </span>
                      <input
                        type="text"
                        value={this.state.donationAmount}
                        onChange={this.handleAmountChange}
                        placeholder="0.00"
                        className="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                        style={{ '--tw-ring-color': '#7f0b86' }}
                      />
                    </div>
                    <div className="relative">
                      <select
                        value={this.state.currency}
                        onChange={this.handleCurrencyChange}
                        className="appearance-none px-3 py-2 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent bg-white"
                        style={{ '--tw-ring-color': '#7f0b86' }}
                      >
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                        <option value="CAD">CAD</option>
                        <option value="AUD">AUD</option>
                        <option value="JPY">JPY</option>
                        <option value="INR">INR</option>
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="px-6 pb-2">
                  <button 
                    onClick={this.handleDonate}
                    className="w-full text-white py-2.5 px-4 rounded-full font-medium text-sm transition duration-200 mb-3"
                    style={{ backgroundColor: '#7f0b86' }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#6a0a72'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#7f0b86'}
                  >
                    DONATE
                  </button>
                  
                  <SocialComponent />
                </div>

                {/* Donor Count */}
                <div className="border-t border-gray-200">
                  <div className="p-6">
                    <p className="text-gray-600 text-sm">Number of Donors</p>
                    <p className="text-2xl font-bold">{this.state.donors}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(App);